// extracted by mini-css-extract-plugin
export default {"header":"N2fH7NlCTUplfgDgYPBC","headerMain":"vYLjCpjZnvqaqCKHzXUx","content":"GNYWCKjoJP0gD31UiPsj","space":"Z6hA0zUu8Nv7NVvTTbmx","placeHolderShimmer":"dV5P1nKFNfn1GESTPbP8"};